import PropTypes from "prop-types";

// Components
import DoubleCheckingButton from "@Layouts/components/Buttons/DoubleCheckingButton";

// SVG Icons
import SimpleTrash from "@/assets/icons/motivators/spiffSetup/trash.svg";
import TrashIconGrayDisabled from "@/assets/icons/motivators/spiffSetup/trash-gray-disabled.svg";
import TrashIconWhite from "@/assets/icons/motivators/spiffSetup/trash-white.svg";

function Delete(props) {
	const { apiRef, buttonWidth, deleteTitle, disabled, onDeleteAction, confirmationButtonClasses } = props;

	const onDeleteHandler = () => {
		const selectedIds = apiRef.current.getSelectedRows();
		onDeleteAction?.([...selectedIds.values()].map((item) => item.id || item._id));
	};

	return (
		<DoubleCheckingButton
			disabled={disabled || false}
			title={deleteTitle || "Remove"}
			buttonWidth={buttonWidth}
			icon={disabled ? <img src={TrashIconGrayDisabled} /> : <img src={SimpleTrash} />}
			iconHover={<img src={SimpleTrash} />}
			endIcon={<img src={TrashIconWhite} className="w-4.5 !mt-[-1px]" />}
			onDeleteAction={onDeleteHandler}
			confirmationButtonClasses={confirmationButtonClasses ?? undefined}
		/>
	);
}

Delete.propTypes = {
	apiRef: PropTypes.shape({
		current: PropTypes.object,
	}),
	buttonWidth: PropTypes.string,
	deleteTitle: PropTypes.string,
	disabled: PropTypes.bool,
	onDeleteAction: PropTypes.func,
	confirmationButtonClasses: PropTypes.string,
};

export default Delete;
